import { useTranslation } from 'react-i18next';
import { useNavigate } from '@/providers/RouterShim';
import type { Branch } from '../../../../@types/Branch';
import { Button } from '../../../../styled-components/components/Button';
import InfoBox from '../../../../styled-components/components/InfoBox';
import ShallowPanel, {
  ShallowPanelBody,
  ShallowPanelFooter,
} from '../../../../styled-components/components/Panel/ShallowPanel';
import {
  FooterAction,
  FooterActionItem,
} from '../../../../styled-components/components/Panel/wrapper';

interface MissingAddressProps {
  onClose: () => void;
  branch?: Branch;
}

export const MissingAddress = ({ onClose, branch }: MissingAddressProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'createVehiclePanel']);

  return (
    <ShallowPanel title={t('missingAddressTitle', { ns: 'createVehiclePanel' })} onClose={onClose}>
      <ShallowPanelBody>
        <InfoBox>
          {t('missingAddressDescription', { ns: 'createVehiclePanel', branchName: branch?.name })}
        </InfoBox>
      </ShallowPanelBody>
      <ShallowPanelFooter>
        <FooterAction>
          <FooterActionItem>
            <Button onClick={() => onClose()} $tone="secondary">
              {t('cancel', { ns: 'common' })}
            </Button>
          </FooterActionItem>
          <FooterActionItem>
            <Button
              onClick={() =>
                navigate(`/${branch?.id}/settings/retailer-information/about-us#section-address`)
              }
              $tone="primary"
            >
              {t('addAddress', { ns: 'createVehiclePanel' })}
            </Button>
          </FooterActionItem>
        </FooterAction>
      </ShallowPanelFooter>
    </ShallowPanel>
  );
};
